import { use } from 'react';

import { AuthContext } from './AuthContext';
import type { AuthContextValue } from './AuthContext';

/**
 * The signed-in session.
 *
 * @throws when used outside `AuthProvider` — a component that silently believes
 *         nobody is signed in is worse than one that fails loudly
 */
export function useAuth(): AuthContextValue {
  const context = use(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used inside an AuthProvider.');
  }
  return context;
}
